module.exports = __webpack_public_path__ + "static/media/student-summary-20p.bb1507f4.png";